import { createFeatureSelector, createSelector, createSelectorFactory } from '@ngrx/store';
import { closureFiltertoQuery, closureQueryParmsFactory } from '../../models';
import { PressureUnitOfMeasureConverter } from '../../models/query-result.model';
import * as fromStore from '../reducers/closures.reducer';

const state = createFeatureSelector<fromStore.State>(fromStore.closuresFeatureKey);
const selectDiameters = createSelector(state, state => state.diameters);
const selectClosureDesignCodes = createSelector(state, state => state.designCodes);
const selectClosureDesignFactors = createSelector(state, state => state.designFactors);
const selectWallThicknesses = createSelector(state, state => state.wallThicknesses);
const selectHingeOrientations = createSelector(state, state => state.hingeOrientations);
const selectPressureRatings = createSelector(state, state => state.pressureRatings);
const selectClampRings = createSelector(state, state => state.clampRings);
const selectFlangeClasses = createSelector(state, state => state.flangeClasses);
const selectClassRatings = createSelector(state, state => state.classRatings);

const selectHasLoadedLookups = createSelector(selectDiameters, selectClosureDesignCodes, selectClosureDesignFactors,
  (diameters, codes, factors) => diameters.length > 0 || codes.length > 0 || factors.length > 0);

const selectFilteredProducts = createSelector(state, state => state.filteredProducts);

const selectActiveClosureId = createSelector(state, state => state.activeClosureId);
const selectActiveClosure = createSelector(state, selectActiveClosureId, (state, id) => state.filteredProducts.find(f => f.id === id));
const selectActiveClosurePartNumber = createSelector(selectActiveClosure, closure => closure?.partNumber);

const selectActiveClosureDetail = createSelector(state, state => state.activeClosureDetail);
const selectClosureHasDrawing = createSelector(selectActiveClosureDetail, detail => detail?.hasDrawing || false);

const selectFilter = createSelector(state, state => state.filter || closureQueryParmsFactory({}));
const selectFilterQuerystring = createSelector(selectFilter, filt => closureFiltertoQuery(new PressureUnitOfMeasureConverter(), filt));

const selectCurrentDiameterId = createSelector(selectFilter, filt => filt.nominalSize);
const selectCurrentDiameterNumericValue = createSelector(selectDiameters, selectCurrentDiameterId, (diameters, id) => diameters.find(f => f.id === id)?.numericValue || -1);

const selectCurrentFlangeOptionValue = createSelector(selectFilter, filt => filt.flanged);
const selectCurrentFlangeOptionValueText = createSelector(selectCurrentFlangeOptionValue, val => val === undefined ? 'foo' : !!val ? 'flange' : 'noFlange');

const selectMaxDesignPressure = createSelector(selectFilter, filt => filt.maxDesignPressure);

const selectLoaders = createSelector(state, state => state.loaders);
const selectLoader = (name: fromStore.Loaders) =>
  createSelector(selectLoaders, (loaders: fromStore.Loaders[]) => !!((loaders || []).find(f => f === name)));

export const selectDrawingDictionary = createSelector(state, state => state.drawingDictionary);

export {
  selectDiameters,
  selectClosureDesignCodes,
  selectClosureDesignFactors,
  selectHasLoadedLookups,
  selectFilteredProducts,
  selectActiveClosureId,
  selectActiveClosure,
  selectActiveClosurePartNumber,
  selectActiveClosureDetail,
  selectClosureHasDrawing,
  selectFilter,
  selectFilterQuerystring,
  selectCurrentDiameterId,
  selectCurrentDiameterNumericValue,
  selectCurrentFlangeOptionValue,
  selectCurrentFlangeOptionValueText,
  selectMaxDesignPressure,
  selectLoaders,
  selectLoader,
  selectWallThicknesses,
  selectHingeOrientations,
  selectClampRings,
  selectPressureRatings,
  selectFlangeClasses,
  selectClassRatings
}
